export const CHARTMIND_ORG_ADMIN_ROLES = ['chartmind-admin', 'chartmind-kijabe'];

export function isChartmindOrgAdminRole(role) {
  return CHARTMIND_ORG_ADMIN_ROLES.includes(role);
}

